<template>
  <modal
    title="Apply gift card"
    :open="open"
    @close="closeModal"
  >
    <form @submit.prevent="submit">
      <p class="small-text">
        Please note Gift Cards are only eligible for use on Card Ladder memberships. This GiftCard cannot be combined for use with additional products (i.e. Collectors Club Premium). If you have any questions, please contact Kristina at contact@cardladder.com for more information.
      </p>

      <text-input
        id="giftcardcode"
        v-model.trim="giftCardCode"
        type="text"
        label="Gift Card Code"
      />

      <p v-if="error" class="error">
        {{ error }}
      </p>
      <p v-if="checking" class="success">
        Checking...
      </p>
      <p v-if="response && response.remainingValue" class="success">
        Available balance of {{ $filters.currency(response.remainingValue) }}
      </p>

      <btn type="submit" :disabled="response === null">
        Apply
      </btn>
    </form>
  </modal>
</template>

<script>
import firebase from 'firebase/compat/app';
import debounce from 'lodash.debounce';

export default {
  props: {
    open: Boolean,
  },

  data() {
    return {
      giftCardCode: '',
      error: '',
      response: null,
      checking: false,
    };
  },

  created() {
    this.checkCode = debounce(this.checkCode, 500);
  },

  watch: {
    giftCardCode(value) {
      if (value) {
        this.checkCode();
      } else {
        this.reset();
      }
    },
  },

  methods: {
    async checkCode() {
      this.checking = true;
      this.error = '';
      this.response = null;

      try {
        const { data } = await firebase.functions().httpsCallable('httpGiftUpGiftCardRetrieve')({ code: this.giftCardCode });

        if (data.valid) {
          this.response = data;
        } else {
          this.error = 'Not a valid gift card or the balance is empty';
        }
      } catch (e) {
        this.error = 'Not a valid gift card or the balance is empty';
      }

      this.checking = false;
    },

    submit() {
      this.$emit('submit', this.response);
      this.reset();
      this.$emit('close');
    },

    reset() {
      this.giftCardCode = '';
      this.error = '';
      this.response = null;
      this.checking = false;
    },

    closeModal() {
      this.reset();
      this.$emit('close');
    },
  },
};
</script>
